"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.layoutThemes = exports.layoutColorThemes = void 0;

var _styledComponents = require("styled-components");

var layoutColorThemes = [undefined, 'default', 'alt'];
exports.layoutColorThemes = layoutColorThemes;
var layoutThemes = (0, _styledComponents.css)(["background-color:", ";"], function (props) {
  return props.theme["c_background_".concat(props.colorTheme)];
});
exports.layoutThemes = layoutThemes;